<template>
    <div v-loading="loading" :style="{height: this.data.length === 0 && this.prob.length === 0 ? '100vh' : 'auto'}">
        <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
        <div class="container" style="height: calc(100% - 100px);">
            <div v-if="this.data.length === 0 && !this.loading" class="text-center d-flex flex-column justify-content-center align-items-center h-75">
                <h4 class="my-3">{{ this.team }}</h4>
                <h5 class="my-3">离散度</h5>
                <span class="mb-3">暂无数据</span>
                <hr class="w-100">
                <h5 class="my-3">当前凯利指数</h5>
                <span class="mb-3">暂无数据</span>
                <el-button type="primary" @click="fetchChartData()">获取数据</el-button>
            </div>
            <div class="text-center" v-if="this.data.length > 0">
                <div class="fs-14 mt-3">
                    <span class="me-3">{{ this.league }}</span>
                    <span>{{ this.date }}</span>
                </div>
                <h4 class="my-3">{{ this.team }}</h4>
                <h5 class="mt-3">离散度</h5>
                <div ref="myChart" style=" height: 500px; margin: 0 auto;"></div>
                <h5 class="mt-4">当前凯利指数</h5>
                <div ref="myBarChart" :style="this.isMobile ? 'height: 850px; margin: 0 auto;':'height: 350px; margin: 0 auto;'"></div>
                <el-button type="text" @click="fetchChartData()">刷新数据</el-button>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <h3 class="fs-16">胜平负（让球胜平负）</h3>
                    <el-table :data="results.wdlList" border stripe :header-cell-class-name="'bg-primary-subtle text-dark fs-12 py-1 text-center'" :cell-class-name="'py-1 text-center px-0'" style="width: 400px">
                        <el-table-column prop="hd" label="让球" width="50"></el-table-column>
                        <el-table-column prop="w" label="胜(让胜) / 赔率">
                            <template slot-scope="scope">
                                <div class="border-bottom" style="margin: 0 -10px;">{{ toPercentage(scope.row.w) }}</div>
                                <div style="margin: 0 -10px;">{{ parseFloat(1/scope.row.w).toFixed(2) }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="d" label="平(让平) / 赔率">
                            <template slot-scope="scope">
                                <div class="border-bottom" style="margin: 0 -10px;">{{ toPercentage(scope.row.d) }}</div>
                                <div style="margin: 0 -10px;">{{ parseFloat(1/scope.row.d).toFixed(2) }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="l" label="负(让负) / 赔率">
                            <template slot-scope="scope">
                                <div class="border-bottom" style="margin: 0 -10px;">{{ toPercentage(scope.row.l) }}</div>
                                <div style="margin: 0 -10px;">{{ parseFloat(1/scope.row.l).toFixed(2) }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="mt-4">
                        <h3 class="fs-16">双胜彩</h3>
                        <div class="d-flex border fs-14 double-chaness">
                            <div class="flex-fill text-center">
                                <p class="border-bottom my-0 py-1 fw-bold fs-12 bg-primary-subtle border-end">胜平</p>
                                <p class="border-bottom border-end my-0 py-1">{{ toPercentage(1 - this.lose) }}</p>
                                <p class="my-0 py-1 border-end">{{ parseFloat(1/(1 - this.lose)).toFixed(2) }}</p>
                            </div>
                            <div class="flex-fill text-center">
                                <p class="border-bottom my-0 py-1 fw-bold fs-12 bg-primary-subtle border-end">平负</p>
                                <p class="border-bottom border-end my-0 py-1">{{ toPercentage(1 - this.win) }}</p>
                                <p class="my-0 py-1 border-end">{{ parseFloat(1/(1 - this.win)).toFixed(2) }}</p>
                            </div>
                            <div class="flex-fill text-center">
                                <p class="border-bottom my-0 py-1 fw-bold fs-12 bg-primary-subtle">胜负</p>
                                <p class="border-bottom my-0 py-1">{{ toPercentage(this.win + this.lose) }}</p>
                                <p class="my-0 py-1">{{ parseFloat(1/(this.win + this.lose)).toFixed(2) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4">
                        <h3 class="fs-16">全场比分</h3>
                        <el-table :data="results.winProb.slice(0, 10)" border stripe :header-cell-class-name="'bg-primary-subtle text-dark fs-12 py-1 text-center'" :cell-class-name="'py-1 text-center px-0'" style="width: 400px">
                            <el-table-column prop="score" label="主胜比分"></el-table-column>
                            <el-table-column prop="value" label="概率">
                                <template slot-scope="scope">
                                    <div>{{toPercentage(scope.row.value)}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="value" label="赔率">
                                <template slot-scope="scope">
                                    <div>{{ parseFloat(1/scope.row.value).toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-table :data="results.drawProb.slice(0, 10)" border stripe :header-cell-class-name="'bg-primary-subtle text-dark fs-12 py-1 text-center'" :cell-class-name="'py-1 text-center px-0'" style="width: 400px">
                            <el-table-column prop="score" label="平局比分"></el-table-column>
                            <el-table-column prop="value" label="概率">
                                <template slot-scope="scope">
                                    <div>{{toPercentage(scope.row.value)}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="value" label="赔率">
                                <template slot-scope="scope">
                                    <div>{{ parseFloat(1/scope.row.value).toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-table :data="results.loseProb.slice(0, 10)" border stripe :header-cell-class-name="'bg-primary-subtle text-dark fs-12 py-1 text-center'" :cell-class-name="'py-1 text-center px-0'" style="width: 400px">
                            <el-table-column prop="score" label="客胜比分"></el-table-column>
                            <el-table-column prop="value" label="概率">
                                <template slot-scope="scope">
                                    <div>{{toPercentage(scope.row.value)}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="value" label="赔率">
                                <template slot-scope="scope">
                                    <div>{{ parseFloat(1/scope.row.value).toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div>
                    <h3 class="fs-16">让分盘</h3>
                    <el-table :data="results.ahdList" border stripe :header-cell-class-name="'bg-primary-subtle text-dark fs-12 py-1 text-center'" :cell-class-name="'py-1 text-center px-0'" style="width: 400px">
                        <el-table-column prop="hdpW" label="主队水位"></el-table-column>
                        <el-table-column prop="hd" label="让球"></el-table-column>
                        <el-table-column prop="hdpL" label="客队水位"></el-table-column>
                    </el-table>
                    </div>
                    <div class="mt-4">
                        <h3 class="fs-16">大小球</h3>
                        <el-table :data="results.bsList" border stripe :header-cell-class-name="'bg-primary-subtle text-dark fs-12 py-1 text-center'" :cell-class-name="'py-1 text-center px-0'" style="width: 400px">
                            <el-table-column prop="over" label="大球"></el-table-column>
                            <el-table-column prop="bsHd" label="盘口"></el-table-column>
                            <el-table-column prop="under" label="小球"></el-table-column>
                        </el-table>
                    </div>
                    <div class="mt-4">
                        <h3 class="fs-16">总进球数</h3>
                        <el-table :data="results.scoreList" border stripe :header-cell-class-name="'bg-primary-subtle text-dark fs-12 py-1 text-center'" :cell-class-name="'py-1 text-center px-0'" style="width: 400px">
                            <el-table-column prop="snum" label="进球数"></el-table-column>
                            <el-table-column prop="prob" label="概率">
                                <template slot-scope="scope">
                                    <div>{{toPercentage(scope.row.prob)}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="val" label="赔率"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <!-- <div class="px-3">
                <p v-for="(item, index) in this.prob" :key="index">
                    <span v-if="item.value>=0.001">{{ item.score }}：</span>
                    <span v-if="item.value>=0.001">{{toPercentage(item.value)}}</span>
                    <span v-if="item.value>=0.001" class="ms-2">{{ parseFloat(1 / item.value).toFixed(2) }}</span>
                </p>
            </div> -->
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import Nav from './nav.vue';
import Footer from './footer.vue';
import {kailiUrl, kailiCrawlerUrl} from '../../constants/http.config';
import { poissonDist,calculateScores, checkDevice, fbBsVal } from '../../utils/utils'
export default {
    inject: ['reload'],
    components: { Nav,Footer },
    data() {
        return {
            team: '',
            isDark: false,
            loading: false,
            data: [],
            kailiData: [],
            goalList: [0,1,2,3,4,5,6,7,8,9,10],
            id: '',
            league: '',
            date: '',
            isMobile: false,
            homeXg: 0,
            awayXg: 0,
            win: 0,
            draw: 0,
            lose: 0,
            prob: [],
            winProb: [],
            drawProb: [],
            loseProb: [],
            wdlList: [],
            results: {
                hwin: [],
                awin: [],
                doubleChance: [],
                r1w: [], r2w: [], r3w: [],
                r1d: [], r2d: [], r3d: [],
                s1w: [], s2w: [], s3w: [],
                s1d: [], s2d: [], s3d: [],
                winProb: [],
                drawProb: [],
                loseProb: [],
                wdlList: [],
                ahdList: [],
                bsList: [],
                totalScoreList: []
            }
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.team = this.$route.query.teams;
        document.title = this.team + ' - 泊松分布';
        // console.log(this.team);
        this.isMobile = checkDevice();
        let poissonList = [];
        this.getChartData(this.id)
        for (let i = 0; i < this.goalList.length; i++) {
            const elm = this.goalList[i];
            const homeXg = this.$route.query.hxg;
            const awayXg = this.$route.query.axg;
            const h = this.poissonDist(elm, homeXg, false);
            const a = this.poissonDist(elm, awayXg, false);
            const res = {
                key:i ,home: h, away: a
            }
            // console.log(elm,h,a);
            
            poissonList.push(res);
        }
        // console.log(poissonList);
        this.prob = this.calculateScores(poissonList).sort((a, b) => b.value - a.value);
        // console.log(this.prob);
        this.analyzeProbabilities();
        // console.log('dc',this.results.doubleChance);
        
        // let homeWin = 0;
        // let awayWin = 0;
        // let hwin = [];
        // let awin = [];
        // let r1w = [];
        // let r1d = [];
        // let r2w = [];
        // let r2d = [];
        // let r3w = [];
        // let r3d = [];
        // let s1w = [];
        // let s1d = [];
        // let s2w = [];
        // let s2d = [];
        // let s3w = [];
        // let s3d = [];
        // // 计算主队赢球概率
        // for (let i = 0; i < poissonList.length; i++) {
        //     const homePb = poissonList[i].home;
        //     const awaySum = poissonList.slice(0, i).reduce((acc, curr) => acc + curr.away, 0);
        //     homeWin += homePb * awaySum;
        // }
        // // 计算客队赢球概率
        // for (let i = 1; i < poissonList.length; i++) {
        //     const awayPb = poissonList[i].away;
        //     const homeSum = poissonList.slice(0, i).reduce((acc, curr) => acc + curr.home, 0);
        //     awayWin += awayPb * homeSum;
        // }
        // for (let index = 0; index < this.prob.length; index++) {
        //     const hscore = this.prob[index].h;
        //     const ascore = this.prob[index].a;
        //     // console.log(hscore,ascore,hscore > ascore);
        //     if (hscore > ascore) {
        //         hwin.push(this.prob[index].value);
        //         this.winProb.push(this.prob[index]);
        //         // console.log('主胜',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore === ascore) {
        //         this.drawProb.push(this.prob[index]);
        //         // console.log('主胜',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore < ascore) {
        //         awin.push(this.prob[index].value);
        //         this.loseProb.push(this.prob[index]);
        //         // console.log('客胜',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore-1 > ascore) {
        //         r1w.push(this.prob[index].value);
        //         console.log('让1胜',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore-2>ascore) {
        //         r2w.push(this.prob[index].value);
        //         // console.log('让2胜',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore-3>ascore) {
        //         r3w.push(this.prob[index].value);
        //         // console.log('让3胜',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore-ascore===1) {
        //         r1d.push(this.prob[index].value);
        //         console.log('让1平',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore-ascore===2) {
        //         r2d.push(this.prob[index].value);
        //         // console.log('让2平',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore-ascore===3) {
        //         r3d.push(this.prob[index].value);
        //         // console.log('让3平',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore+1 > ascore) {
        //         s1w.push(this.prob[index].value);
        //         // console.log('受1胜',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore+2>ascore) {
        //         s2w.push(this.prob[index].value);
        //         // console.log('受2胜',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (hscore+3>ascore) {
        //         s3w.push(this.prob[index].value);
        //         // console.log('受3胜',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (ascore-hscore===1) {
        //         s1d.push(this.prob[index].value);
        //         // console.log('受1平',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (ascore-hscore===2) {
        //         s2d.push(this.prob[index].value);
        //         // console.log('受2平',this.prob[index].score,this.prob[index].value);
        //     }
        //     if (ascore-hscore===3) {
        //         s3d.push(this.prob[index].value);
        //         // console.log('受3平',this.prob[index].score,this.prob[index].value);
        //     }
        // }
        // const hwinSum = Number(parseFloat(hwin.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const awinSum = Number(parseFloat(awin.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const r3wSum = Number(parseFloat(r3w.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const r3dSum = Number(parseFloat(r3d.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const r2wSum = Number(parseFloat(r2w.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const r2dSum = Number(parseFloat(r2d.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const r1wSum = Number(parseFloat(r1w.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const r1dSum = Number(parseFloat(r1d.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const s3wSum = Number(parseFloat(s3w.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const s3dSum = Number(parseFloat(s3d.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const s2wSum = Number(parseFloat(s2w.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const s2dSum = Number(parseFloat(s2d.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const s1wSum = Number(parseFloat(s1w.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // const s1dSum = Number(parseFloat(s1d.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(4));
        // this.win = hwinSum;
        // this.lose = awinSum;
        // this.wdlList.push({
        //     hd: -3,
        //     w: Number(parseFloat(r3wSum).toFixed(4)),
        //     d: Number(parseFloat(r3dSum).toFixed(4)),
        //     l: Number(parseFloat(1-(r3wSum+r3dSum)).toFixed(4))
        // })
        // this.wdlList.push({
        //     hd: -2,
        //     w: Number(parseFloat(r2wSum).toFixed(4)),
        //     d: Number(parseFloat(r2dSum).toFixed(4)),
        //     l: Number(parseFloat(1-(r2wSum+r2dSum)).toFixed(4))
        // })
        // this.wdlList.push({
        //     hd: -1,
        //     w: Number(parseFloat(r1wSum).toFixed(4)),
        //     d: Number(parseFloat(r1dSum).toFixed(4)),
        //     l: Number(parseFloat(1-(r1wSum+r1dSum)).toFixed(4))
        // })
        // this.wdlList.push({
        //     hd: 0,
        //     w: Number(parseFloat(hwinSum).toFixed(4)),
        //     d: Number(parseFloat(1-(hwinSum + awinSum)).toFixed(4)),
        //     l: Number(parseFloat(awinSum).toFixed(4))
        // })
        // this.wdlList.push({
        //     hd: 1,
        //     w: Number(parseFloat(s1wSum).toFixed(4)),
        //     d: Number(parseFloat(s1dSum).toFixed(4)),
        //     l: Number(parseFloat(1-(r1wSum+r1dSum)).toFixed(4))
        // })
        // this.wdlList.push({
        //     hd: 2,
        //     w: Number(parseFloat(s2wSum).toFixed(4)),
        //     d: Number(parseFloat(s2dSum).toFixed(4)),
        //     l: Number(parseFloat(1-(s2wSum+s2dSum)).toFixed(4))
        // })
        // this.wdlList.push({
        //     hd: 3,
        //     w: Number(parseFloat(s3wSum).toFixed(4)),
        //     d: Number(parseFloat(s3dSum).toFixed(4)),
        //     l: Number(parseFloat(1-(s3wSum+s3dSum)).toFixed(4))
        // })
        // console.log(r1wSum,r1dSum);
        
        // this.getChartData(this.id);
        
    },
    methods: {
        poissonDist,
        calculateScores,
        ///判断设备
        checkDevice,
        fbBsVal,
        ///抓取数据
        fetchChartData(){
            this.loading = true
            // const apiUrl = 'https://api.qsda.net/api/crawler/kaili/' + this.id;
            // console.log(apiUrl);
            fetch(kailiCrawlerUrl + this.id, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.code == 200) {
                    this.loading = false;
                    // this.$notify({
                    //     title: '抓取成功',
                    //     message: data.data,
                    //     type: 'success',    
                    //     // duration: 0
                    // });
                    this.$alert('更新数据成功！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                } else {
                    this.$notify.error({
                        title: '抓取失败',
                        message: '未知错误，请重试'
                    });
                }
            });
        },
        ///读取数据
        getChartData(id) {
            // this.loading = false
            // const url = 'https://api.qsda.net/api/match/kaili/'+id;
            fetch(kailiUrl + id)
            .then(response => response.json())
            .then(data => {
                // console.log(data);
                let chartData = data.data.data.reverse();
                this.data = chartData;
                this.kailiData = data.data.kaili
                if (chartData.length > 0) {
                    this.loading = false;
                }
                this.team = data.data.team;
                document.title = this.team;
                this.league = data.data.league;
                this.date = data.data.date;
                console.log(this.league,this.date);
                //x轴数据
                var xData = chartData.map((item) => {
                    let date = new Date(item.time);
                    let hours = date.getHours();
                    let minutes = date.getMinutes();
                    // 如果小时或分钟小于10，前面添加一个'0'
                    if (hours < 10) hours = '0' + hours;
                    if (minutes < 10) minutes = '0' + minutes;
                    let timeStr = hours + ':' + minutes;
                    return timeStr;
                });
                //y轴数据
                var win = chartData.map((item) => {
                    return item.win;
                })
                var draw = chartData.map((item) => {
                    return item.draw;
                });
                var lose = chartData.map((item) => {
                    return item.lose;
                });
                var companyList = this.kailiData.list.map((item) => {
                    return item.company;
                });
                var w = this.kailiData.list.map((item) => {
                    return item.w;
                });
                var d = this.kailiData.list.map((item) => {
                    return item.d;
                })
                var l = this.kailiData.list.map((item) => {
                    return item.l;
                })
                // var r = this.kailiData.list.map((item) => {
                // return item.d_rate;
                // })
                this.$nextTick(() => {
                    this.initChart(xData, win, draw, lose);
                    this.initBarChart(companyList, w, d, l);
                });
            }).catch((err) => {
                console.log(err);
                this.$message.error('获取数据失败');
                this.loading = false;
                this.chartData = [];
                this.kailiData = [];
            });
        },
        ///离散线图
        initChart(xData, win, draw, lose) {
            const myChart = echarts.init(this.$refs.myChart);
            myChart.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['主胜', '平局', '客胜']
                },
                grid: {
                    left: '5%',
                    right: '5%',
                    bottom: '8%'
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData,
                    axisTick: {
                        interval: 1
                    },
                    axisLabel: {
                        interval: 1
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        inside: true,
                        margin: 0,
                        verticalAlign: "bottom",
                        color: '#ccc'
                    }
                },
                series: [
                    {
                    name: '主胜',
                    type: 'line',
                    itemStyle: {
                        color: "#ee6666"
                    },
                    data: win
                    },
                    {
                    name: '平局',
                    type: 'line',
                    data: draw
                    },
                    {
                    name: '客胜',
                    type: 'line',
                    data: lose
                    }
                ]
            });
        },
        ///凯利指数柱形图
        initBarChart(x,w,d,l) {
            const myChart = echarts.init(this.$refs.myBarChart);
            let xOption = {}
            let yOption = {}
            if (this.isMobile) {
                // console.log('11111');
                xOption = {
                    type: 'value',
                    min: function(value){
                        return (value.min - 0.05).toFixed(2)
                    },
                    max: function(value){
                        return value.max
                    },
                }
                yOption = {
                    type: 'category',
                    data: x,
                    axisLabel: {
                            rotate: -35 // 设置X轴文字旋转角度为-45度
                        }
                }
            }else{
                console.log('22222');
                xOption = {
                    type: 'category',
                    data: x,
                    axisLabel: {
                            rotate: -35 // 设置X轴文字旋转角度为-45度
                        }
                };
                yOption = {
                    type: 'value',
                    min: function(value){
                        return (value.min - 0.05).toFixed(2)
                    },
                    max: function(value){
                        return value.max
                    },
                }
            }
            myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                },
                legend: {},
                grid: {
                    left: this.isMobile ? '10%' : '5%',
                    right: this.isMobile ? '1%' : '5%',
                    // bottom: '3%',
                },
                yAxis: yOption,
                xAxis: xOption,
                series: [
                    {
                        name: '主胜',
                        type: 'bar',
                        data: w,
                        itemStyle: {
                            color: "#ee6666"
                        },
                        label: {
                            show: true,
                            verticalAlign: 'middle',
                            position: this.isMobile ? 'right' : 'top',
                        },
                        markLine: {
                            data: [{ type: 'average', name: 'wAvg' }]
                        }
                    },
                    {
                        name: '平',
                        type: 'bar',
                        data: d,
                        label: {
                            show: true,
                            verticalAlign: 'middle',
                            position: this.isMobile ? 'right' : 'top',
                        },
                        markLine: {
                            data: [{ type: 'average', name: 'dAvg' }]
                        }
                    },
                    {
                        name: '客胜',
                        type: 'bar',
                        data: l,
                        label: {
                            show: true,
                            verticalAlign: 'middle',
                            position: this.isMobile ? 'right' : 'top',
                        },
                        markLine: {
                            data: [{ type: 'average', name: 'lAvg' }]
                        }
                    }
                ]
            });
        },
        //转换百分数
        toPercentage(decimal) {
            let percentage = decimal * 100;
            return percentage.toFixed(2) + "%";
        },
        // 计算单一结果的总和
        sumArray(arr) {
            return Number(parseFloat(arr.reduce((acc, val) => acc + val, 0)).toFixed(4));
        },
        // 处理让球/受球情况
        processHandicap(hscore, ascore, value, index) {
            const { value: val, score } = this.prob[index];
            const diff = hscore - ascore;

            // 处理让球和受球的胜和平
            for (let i = 1; i <= 3; i++) {
                // 让球胜：hscore - i > ascore
                if (hscore - i > ascore) {
                this.results[`r${i}w`].push(val);
                // console.log(`让${i}胜`, score, val);
                }
                // 让球平：hscore - ascore === i
                if (diff === i) {
                this.results[`r${i}d`].push(val);
                // console.log(`让${i}平`, score, val);
                }
                // 受球胜：hscore + i > ascore
                if (hscore + i > ascore) {
                this.results[`s${i}w`].push(val);
                // console.log(`受${i}胜`, score, val);
                }
                // 受球平：ascore - hscore === i
                if (ascore - hscore === i) {
                this.results[`s${i}d`].push(val);
                // console.log(`受${i}平`, score, val);
                }
            }
        },
        converToHandicap(number){
            const rules1 = [
                { min: 0, max: 15, result: 0 },//平
                { min: 16, max: 25, result: 0.25 },//平/半
                { min: 26, max: 50, result: 0.5 },//半球
                { min: 51, max: 75, result: 0.75 },//半/一
                { min: 76, max: 100, result: 1 },//一球
                { min: 101, max: 125, result: 1.25 },//一球/球半
                { min: 126, max: 150, result: 1.5 },//球半
                { min: 151, max: 175, result: 1.75 },//球半/两球
                { min: 176, max: 200, result: 2 },//两球
                { min: 201, max: 225, result: 2.25 },//两球/两球半
                { min: 226, max: 250, result: 2.5 },//两球半
                { min: 251, max: 275, result: 2.75 },//两球半/三球
                { min: 276, max: 300, result: 3 },//三球
                { min: 301, max: 325, result: 3.25 },//三球/三球半
                { min: 326, max: 350, result: 3.5 },//三球半
                { min: 351, max: 375, result: 3.75 },//三球半/四球
                { min: 376, max: 400, result: 4 },//四球
                { min: 401, max: 425, result: 4.25 },//四球/四球半
                { min: 426, max: 450, result: 4.5 },//四球半
                { min: 451, max: 475, result: 4.75 },//四球半/五球
                { min: 476, max: 500, result: 5 },//五球
                { min: 501, max: 525, result: 5.25 },//五球/五球半
                { min: 526, max: 550, result: 5.5 },//五球半
                { min: 551, max: 575, result: 5.75 },//五球半/六球
                { min: 576, max: 600, result: 6 },//六球
                { min: 601, max: 625, result: 6.25 },//六球/六球半
                { min: 626, max: 650, result: 6.5 },//六球半
                { min: 651, max: 675, result: 6.75 },//六球半/七
                { min: 676, max: 700, result: 7 },//七球
            ];
            let results;
            for (const rule of rules1) {
                if (Math.abs(number) >= rule.min && Math.abs(number) <= rule.max) {
                    results = rule.result;
                }
            }
            if (results == null || typeof results == 'undefined') {
                // console.log('无');
                return null;
            }
            return number >= 0 ? results : -results;
        },
        // 分析概率的主方法
        analyzeProbabilities() {
            Object.keys(this.results).forEach(key => {
                this.results[key] = [];
            });
            let ud05 = [];
            let ud15 = [];
            let ud25 = [];
            let ud35 = [];
            let ud45 = [];
            let ud55 = [];
            let ud65 = [];
            let totalScore0 = [];
            let totalScore1 = [];
            let totalScore2 = [];
            let totalScore3 = [];
            let totalScore4 = [];
            let totalScore5 = [];
            let totalScore6 = [];
            let scoreList = [0,1,2,3,4,5,6,7];
            
            const homeXg = Number(this.$route.query.hxg);
            const awayXg = Number(this.$route.query.axg);

            for (let index = 0; index < this.prob.length; index++) {
                const { h: hscore, a: ascore, value } = this.prob[index];
                let bs = [];

                // 基本胜平负
                if (hscore > ascore) {
                    this.results.hwin.push(value);
                    this.results.winProb.push(this.prob[index]);
                } else if (hscore === ascore) {
                    this.results.drawProb.push(this.prob[index]);
                } else {
                    this.results.awin.push(value);
                    this.results.loseProb.push(this.prob[index]);
                }

                //大小球
                if (hscore+ascore === 0) {
                    totalScore0.push(value);
                    // console.log('bs<1.5',hscore,ascore,value);
                }
                if (hscore+ascore < 0.5) {
                    // console.log('bs<0.5',hscore,ascore,value);
                    ud05.push(value);
                }
                if (hscore+ascore === 1) {
                    totalScore1.push(value);
                    // console.log('bs<1.5',hscore,ascore,value);
                }
                if (hscore+ascore < 1.5) {
                    ud15.push(value);
                    // console.log('bs<1.5',hscore,ascore,value);
                }
                if (hscore+ascore === 2) {
                    totalScore2.push(value);
                    // console.log('bs<1.5',hscore,ascore,value);
                }
                if (hscore+ascore < 2.5) {
                    ud25.push(value);
                    // console.log('bs<2.5',hscore,ascore,value);
                }
                if (hscore+ascore === 3) {
                    totalScore3.push(value);
                    // console.log('bs<1.5',hscore,ascore,value);
                }
                if (hscore+ascore < 3.5) {
                    ud35.push(value);
                    // console.log('bs<3.5',hscore,ascore,value);
                }
                if (hscore+ascore === 4) {
                    totalScore4.push(value);
                    // console.log('bs<1.5',hscore,ascore,value);
                }
                if (hscore+ascore < 4.5) {
                    ud45.push(value);
                    // console.log('bs<4.5',hscore,ascore,value);
                }
                if (hscore+ascore === 5) {
                    totalScore5.push(value);
                    // console.log('bs<1.5',hscore,ascore,value);
                }
                if (hscore+ascore < 5.5) {
                    ud55.push(value);
                    // console.log('bs<5.5',hscore,ascore,value);
                }
                if (hscore+ascore === 6) {
                    totalScore6.push(value);
                    // console.log('bs<1.5',hscore,ascore,value);
                }
                if (hscore+ascore < 6.5) {
                    ud65.push(value);
                    // console.log('bs<6.5',hscore,ascore,value);
                }

                // 处理让球/受球情况
                this.processHandicap(hscore, ascore, value, index);
            }
            const ud05Pro = this.sumArray(ud05);
            const ud15Pro = this.sumArray(ud15);
            const ud25Pro = this.sumArray(ud25);
            const ud35Pro = this.sumArray(ud35);
            const ud45Pro = this.sumArray(ud45);
            const ud55Pro = this.sumArray(ud55);
            const ud65Pro = this.sumArray(ud65);
            const ov05Pro = 1-ud05Pro
            const ov15Pro = 1-ud15Pro
            const ov25Pro = 1-ud25Pro
            const ov35Pro = 1-ud35Pro
            const ov45Pro = 1-ud45Pro
            const ov55Pro = 1-ud55Pro
            const ov65Pro = 1-ud65Pro
            const totalS0Pro = this.sumArray(totalScore0);
            const totalS1Pro = this.sumArray(totalScore1);
            const totalS2Pro = this.sumArray(totalScore2);
            const totalS3Pro = this.sumArray(totalScore3);
            const totalS4Pro = this.sumArray(totalScore4);
            const totalS5Pro = this.sumArray(totalScore5);
            const totalS6Pro = this.sumArray(totalScore6);
            const over7Pro = 1-(totalS0Pro+totalS1Pro+totalS2Pro+totalS3Pro+totalS4Pro+totalS5Pro+totalS6Pro);
            console.log(ud05Pro,ud15Pro,ud25Pro,ud35Pro,ud45Pro,ud55Pro,ud65Pro);
            this.results.scoreList = [
                {snum: '0', prob:totalS0Pro, val: 0},
                {snum: '1', prob:totalS1Pro, val: 0},
                {snum: '2', prob:totalS2Pro, val: 0},
                {snum: '3', prob:totalS3Pro, val: 0},
                {snum: '4', prob:totalS4Pro, val: 0},
                {snum: '5', prob:totalS5Pro, val: 0},
                {snum: '6', prob:totalS6Pro, val: 0},
                {snum: '7+', prob:over7Pro, val: 0}
            ]
            
            const bsVal = fbBsVal(homeXg + awayXg);
            let bsHdList = []
            if (bsVal >= 2) {
                bsHdList = [ bsVal + 0.5, bsVal + 0.25, bsVal, bsVal - 0.25, bsVal - 0.5 ]
            }else{
                bsHdList = [ bsVal + 1, bsVal + 0.75, bsVal + 0.5, bsVal + 0.25, bsVal, bsVal - 0.25]
            }
            
            
            for (let index = 0; index < bsHdList.length; index++) {
                if (bsHdList[index] === 1.5) {
                    this.results.bsList.push({
                        bsHd: 1.5,
                        over: Number(parseFloat(1/ov15Pro).toFixed(2)),
                        under: Number(parseFloat(1/ud15Pro).toFixed(2))
                    })
                }
                if (bsHdList[index] === 1.75) {
                    this.results.bsList.push({
                        bsHd: 1.75,
                        over: Number(parseFloat((1-totalS2Pro/2)/((totalS2Pro+totalS3Pro+totalS4Pro+totalS5Pro+totalS6Pro+over7Pro)-totalS2Pro/2)).toFixed(2)),
                        under: Number(parseFloat((1-totalS2Pro/2)/(totalS0Pro+totalS1Pro)).toFixed(2))
                    })
                }
                if (bsHdList[index] === 2) {
                    this.results.bsList.push({
                        bsHd: 2,
                        over: Number(parseFloat((1-totalS2Pro)/(totalS3Pro+totalS4Pro+totalS5Pro+totalS6Pro+over7Pro)).toFixed(2)),
                        under: Number(parseFloat((1-totalS2Pro)/(totalS0Pro+totalS1Pro)).toFixed(2))
                    })
                }
                if (bsHdList[index] === 2.25) {
                    this.results.bsList.push({
                        bsHd: 2.25,
                        over: Number(parseFloat((1-totalS2Pro/2)/(totalS3Pro+totalS4Pro+totalS5Pro+totalS6Pro+over7Pro)).toFixed(2)),
                        under: Number(parseFloat((1-totalS2Pro/2)/((1-(totalS2Pro+totalS3Pro+totalS4Pro+totalS5Pro+totalS6Pro+over7Pro))+totalS2Pro/2)).toFixed(2))
                    })
                }
                if (bsHdList[index] === 2.5) {
                    this.results.bsList.push({
                        bsHd: 2.5,
                        over: Number(parseFloat(1/ov25Pro).toFixed(2)),
                        under: Number(parseFloat(1/ud25Pro).toFixed(2))
                    })
                }
                if (bsHdList[index] === 2.75) {
                    this.results.bsList.push({
                        bsHd: 2.75,
                        over: Number(parseFloat((1-totalS3Pro/2)/((totalS3Pro+totalS4Pro+totalS5Pro+totalS6Pro+over7Pro)-totalS3Pro/2)).toFixed(2)),
                        under: Number(parseFloat((1-totalS3Pro/2)/(totalS0Pro+totalS1Pro+totalS2Pro)).toFixed(2))
                    })
                }
                if (bsHdList[index] === 3) {
                    this.results.bsList.push({
                        bsHd: 3,
                        over: Number(parseFloat((1-totalS3Pro)/(totalS4Pro+totalS5Pro+totalS6Pro+over7Pro)).toFixed(2)),
                        under: Number(parseFloat((1-totalS3Pro)/(totalS0Pro+totalS1Pro+totalS2Pro)).toFixed(2))
                    })
                }
                if (bsHdList[index] === 3.25) {
                    this.results.bsList.push({
                        bsHd: 3.25,
                        over: Number(parseFloat((1-totalS3Pro/2)/(totalS4Pro+totalS5Pro+totalS6Pro+over7Pro)).toFixed(2)),
                        under: Number(parseFloat((1-totalS3Pro/2)/((1-(totalS3Pro+totalS4Pro+totalS5Pro+totalS6Pro+over7Pro))+totalS2Pro/2)).toFixed(2))
                    })
                }
                if (bsHdList[index] === 3.5) {
                    this.results.bsList.push({
                        bsHd: 3.5,
                        over: Number(parseFloat(1/ov35Pro).toFixed(2)),
                        under: Number(parseFloat(1/ud35Pro).toFixed(2))
                    })
                }
                if (bsHdList[index] === 3.75) {
                    this.results.bsList.push({
                        bsHd: 3.75,
                        over: Number(parseFloat((1-totalS4Pro/2)/((totalS4Pro+totalS5Pro+totalS6Pro+over7Pro)-totalS4Pro/2)).toFixed(2)),
                        under: Number(parseFloat((1-totalS4Pro/2)/(totalS0Pro+totalS1Pro+totalS2Pro+totalS3Pro)).toFixed(2))
                    })
                }
                if (bsHdList[index] === 4) {
                    this.results.bsList.push({
                        bsHd: 4,
                        over: Number(parseFloat((1-totalS4Pro)/(totalS5Pro+totalS6Pro+over7Pro)).toFixed(2)),
                        under: Number(parseFloat((1-totalS4Pro)/(totalS0Pro+totalS1Pro+totalS2Pro+totalS3Pro)).toFixed(2))
                    })
                }
                if (bsHdList[index] === 4.25) {
                    this.results.bsList.push({
                        bsHd: 4.25,
                        over: Number(parseFloat((1-totalS4Pro/2)/(totalS5Pro+totalS6Pro+over7Pro)).toFixed(2)),
                        under: Number(parseFloat((1-totalS4Pro/2)/((1-(totalS4Pro+totalS5Pro+totalS6Pro+over7Pro))+totalS4Pro/2)).toFixed(2))
                    })
                }
                if (bsHdList[index] === 4.5) {
                    this.results.bsList.push({
                        bsHd: 4.5,
                        over: Number(parseFloat(1/ov45Pro).toFixed(2)),
                        under: Number(parseFloat(1/ud45Pro).toFixed(2))
                    })
                }
                if (bsHdList[index] === 4.75) {
                    this.results.bsList.push({
                        bsHd: 4.75,
                        over: Number(parseFloat((1-totalS5Pro/2)/((totalS5Pro+totalS6Pro+over7Pro)-totalS5Pro/2)).toFixed(2)),
                        under: Number(parseFloat((1-totalS5Pro/2)/(totalS0Pro+totalS1Pro+totalS2Pro+totalS3Pro+totalS3Pro)).toFixed(2))
                    })
                }
            }

            // 计算汇总结果
            const hwinSum = this.sumArray(this.results.hwin);
            const awinSum = this.sumArray(this.results.awin);
            this.win = hwinSum;
            this.lose = awinSum;
            this.draw = Number(parseFloat(1-hwinSum-awinSum).toFixed(4));

            // 生成wdlList
            const handicaps = [-3, -2, -1, 0, 1, 2, 3];
            handicaps.forEach(hd => {
                const prefix = hd < 0 ? 'r' : 's';
                const absHd = Math.abs(hd);

                if (hd === 0) {
                    this.results.wdlList.push({
                        hd: 0,
                        w: hwinSum,
                        d: Number(parseFloat(1 - (hwinSum + awinSum)).toFixed(4)),
                        l: awinSum
                    });
                    // const wd = 
                } else if (absHd <= 3) {
                    const w = this.sumArray(this.results[`${prefix}${absHd}w`]);
                    const d = this.sumArray(this.results[`${prefix}${absHd}d`]);
                    this.results.wdlList.push({
                        hd,
                        w,
                        d,
                        l: Number(parseFloat(1 - (w + d)).toFixed(4))
                    });
                }
            });

            // 生成 doubleChance
            const wd = Number(parseFloat(1 - awinSum).toFixed(4)); // 胜平
            const dl = Number(parseFloat(1 - hwinSum).toFixed(4)); // 平负
            const wl = hwinSum + awinSum; // 胜负
            this.results.doubleChance.push({
                wd,  // 胜平概率
                dl,  // 平负概率
                wl   // 胜负概率
            });
            console.log(this.results.doubleChance);

            const qsda = Number(parseFloat(homeXg - awayXg).toFixed(2));
            const realHdp = this.converToHandicap(qsda*100)
            const asiaHdp = [realHdp+0.75, realHdp+0.5, realHdp+0.25, realHdp, realHdp-0.25, realHdp-0.5,realHdp-0.75]
            console.log('zzzzz',qsda,realHdp,asiaHdp);
            // let hdpW = 0;
            // let hdpL = 0;
            let res = []
            for (let index = 0; index < asiaHdp.length; index++) {
            console.log('11111',this.results.wdlList[index]);
                const hd = asiaHdp[index];
                let r1w = this.results.wdlList[2].d;//主胜1球
                let r2w = this.results.wdlList[1].d;//主胜2球
                let s1w = this.results.wdlList[4].d;//客胜1球
                let s2w = this.results.wdlList[5].d;//客胜2球
                if (hd===2) {
                    const hdpW = Number(parseFloat((1-r2w)/(this.win-r1w-r2w)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-r1w)/(1-this.win+r1w)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd===1.75) {
                    const hdpW = Number(parseFloat((1-r2w/2)/(this.win-r1w-r2w/2)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-r2w/2)/(1-this.win+r1w)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd===1.5) {
                    const hdpW = Number(parseFloat(1/(this.win-r1w)-1).toFixed(2));
                    const hdpL = Number(parseFloat(1/(1-this.win+r1w)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd===1.25) {
                    const hdpW = Number(parseFloat((1-r1w/2)/(this.win-r1w)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-r1w/2)/(1-this.win+r1w/2)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === 1) {
                    const hdpW = Number(parseFloat((1-r1w)/(this.win-r1w)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-r1w)/(1-this.win)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === 0.75) {
                    const hdpW = Number(parseFloat((1-r1w/2)/(this.win-r1w/2)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-r1w/2)/(1-this.win)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === 0.5) {
                    const hdpW = Number(parseFloat(1/this.win-1).toFixed(2));
                    const hdpL = Number(parseFloat(1/(1-this.win)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === 0.25) {
                    const hdpW = Number(parseFloat((1-this.draw/2)/this.win-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-this.draw/2)/(this.lose+this.draw/2)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if(hd === 0){
                    const hdpW = Number(parseFloat((1-this.draw)/this.win-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-this.draw)/this.lose-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === -0.25) {
                    const hdpW = Number(parseFloat((1-this.draw/2)/(this.win+this.draw/2)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-this.draw/2)/this.lose-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === -0.5) {
                    const hdpW = Number(parseFloat(1/(1-this.lose)-1).toFixed(2));
                    const hdpL = Number(parseFloat(1/this.lose-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === -0.75) {
                    const hdpW = Number(parseFloat((1-s1w/2)/(1-this.lose)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-s1w/2)/(this.lose-s1w/2)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === -1) {
                    const hdpW = Number(parseFloat((1-s1w)/(1-this.lose)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-s1w)/(this.lose-s1w)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === -1.25) {
                    const hdpW = Number(parseFloat((1-s1w/2)/(1-this.lose+s1w/2)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-s1w/2)/(this.lose-s1w)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === -1.5) {
                    const hdpW = Number(parseFloat(1/(1-this.lose+s1w)-1).toFixed(2));
                    const hdpL = Number(parseFloat(1/(this.lose-s1w)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === -1.75) {
                    const hdpW = Number(parseFloat((1-s2w/2)/(1-this.lose+s1w)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-s2w/2)/(this.lose-s1w-s2w/2)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
                if (hd === -2) {
                    const hdpW = Number(parseFloat((1-s2w)/(1-this.lose+s1w)-1).toFixed(2));
                    const hdpL = Number(parseFloat((1-s2w)/(this.lose-s1w-s2w)-1).toFixed(2));
                    this.results.ahdList.push({
                        hd,hdpW,hdpL
                    })
                }
            }
            console.log(this.results.ahdList);
        },
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/sass/global.scss';
    .container{padding-top: 10px;}
    .double-chaness {width: 400px;}
    @media (max-width: 1024px) {
        .double-chaness {width: auto;}
    }
</style>